<template>
  <div>
    <van-nav-bar
      left-arrow
      @click-left="onClickLeft"
    />
    <div class="form-div">
      <div class="row-div">
        <img src="../../assets/accountNumberManagement/notice.png" width="19px" height="19px">
        <div class="notice-div">请提供详细的地址，我们将及时为您更正并在三个工作日内回复</div>
      </div>
      <div class="label-div">联系人姓名</div>
      <van-field v-model="contactName" readonly/>
      <div class="label-div">联系电话</div>
      <van-field v-model="telephone" readonly/>
      <div class="label-div">用户编号<span class="required-span">*</span></div>
      <van-field v-model="userNumber" readonly/>
      <div class="label-div">原地址<span class="required-span">*</span></div>
      <van-field v-model="originalAddress" readonly autosize type="textarea"/>
      <div class="label-div">所在地区<span class="required-span">*</span></div>
      <van-field v-model="newLocation" placeholder="请输入"/>
      <div class="label-div">详细地址<span class="required-span">*</span></div>
      <van-field v-model="detailedAddress" placeholder="请输入" autosize type="textarea"/>
      <div class="button-div">
        <van-button color="#CE0022" class="login-button button-shadow" @click="gasSub()">提交</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import { addConsulting } from '../../api/accountNumberManagement'
import { getUserInfo } from '../../api/login'

export default {
  name: 'CorrectAddress',
  data () {
    return {
      userNumber: '', // 用户编号
      contactName: '', // 联系人姓名
      telephone: '', // 联系电话
      originalAddress: '', // 原地址
      newLocation: '', // 所在地区
      detailedAddress: '', // 详细地址
      timer: null
    }
  },
  mounted () {
    this.contactName = JSON.parse(window.localStorage.userInfo).contacts
    this.telephone = JSON.parse(window.localStorage.userInfo).mobile
    this.userNumber = this.$route.params.userNumber
    this.originalAddress = this.$route.params.detailedAddress
  },
  methods: {
    // 返回
    onClickLeft () {
      this.$router.go(-1)
    },

    // 校验表单字段
    gasSub () {
      if (!this.newLocation) {
        this.$toast('请输入所在地区')
      } else if (!this.detailedAddress) {
        this.$toast('请输入详细地址')
      } else {
        this.onGasSub()
      }
    },

    // 提交
    onGasSub () {
      const that = this
      that.$toast.loading({
        message: '提交中...',
        forbidClick: true,
        duration: 0
      })
      const params = {
        uniUserCode: that.userNumber,
        detailAddress: that.originalAddress,
        appContactName: that.contactName,
        appUserPH: that.telephone,
        region: '所在地区:' + that.newLocation + '。',
        detailAdd: '详细地址:' + that.detailedAddress + '。',
        uniAppContactid: JSON.parse(window.localStorage.userInfo).appContactId
      }
      addConsulting(params).then(res => {
        if (res.data.success) {
          that.getInfo()
          that.$toast.success(res.data.message)
          // 清除延迟执行
          clearTimeout(that.timer)
          // 设置延迟执行,这里设置延迟两秒执行
          that.timer = setTimeout(() => {
            that.$router.go(-3)
          }, 2000)
        } else {
          that.$toast.fail(res.data.message)
        }
      }).catch(() => {
        that.$toast.fail('提交失败')
      })
    },

    // 根据userId获取用户信息
    getInfo () {
      const params = JSON.parse(window.localStorage.userInfo).id
      getUserInfo(params).then(res => {
        if (res.data.success) {
          window.localStorage.userInfo = JSON.stringify(res.data.rows[0])
        }
      }).catch(() => {
      })
    }
  }
}
</script>

<style scoped>
  .van-cell {
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 400;
    padding: 12px 0;
    border-bottom: 1px solid rgba(16, 12, 13, 0.0784313725490196);
  }

  /deep/ .van-field__label {
    color: #62667A;
  }

  /deep/ .van-field__control {
    color: #27282E;
  }

  .label-div {
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #27282E;
    text-align: left;
    margin-top: 15px;
  }

  .form-div {
    padding: 0 4%;
  }

  .required-span {
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #FF7825;
    margin-left: 1px;
  }

  .login-button {
    width: 100%;
    height: 50px;
    border-radius: 8px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    margin-top: 12px;
  }

  .button-shadow {
    box-shadow: 0px 6px 12px rgba(206, 0, 34, 0.3);
  }

  .button-div {
    width: 92%;
    margin-left: 4%;
    margin-top: 8%;
  }

  .row-div {
    display: flex;
  }

  .notice-div {
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 17px;
    color: #999999;
    text-align: left;
    margin-left: 4px;
  }
</style>
